import { render, staticRenderFns } from "./holiday.vue?vue&type=template&id=e2fd9cd2&scoped=true"
import script from "./holiday.vue?vue&type=script&lang=js"
export * from "./holiday.vue?vue&type=script&lang=js"
import style0 from "./holiday.vue?vue&type=style&index=0&id=e2fd9cd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fd9cd2",
  null
  
)

export default component.exports